var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-not-found"},[_c('h1',[_vm._v("非常抱歉,页面走丢咯,"+_vm._s(_vm.smsSecond)+"秒后将返回主页")])])}
var staticRenderFns = []

export { render, staticRenderFns }